var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from "./BaseModel";
import GroupModel from '@/models/GroupModel';
import { map, forEach, flattenDeep } from 'lodash';
;
;
var DiscountModel = /** @class */ (function (_super) {
    __extends(DiscountModel, _super);
    function DiscountModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = hydrated.id;
        _this.discount_id = hydrated.discount_id;
        _this.name = hydrated.name;
        _this.active = hydrated.active;
        _this.amount = hydrated.amount;
        _this.code = hydrated.code;
        _this.type = hydrated.type;
        _this.isOnline = hydrated.isOnline;
        _this.isLocal = hydrated.isLocal;
        _this.menuId = hydrated.menuId;
        _this.minItemCount = hydrated.minItemCount;
        _this.minSubtotal = hydrated.minSubtotal;
        _this.minAfterSubtotal = _this.convertBool(hydrated.minAfterSubtotal);
        _this.target = hydrated.target;
        _this.groups = hydrated.groups;
        _this.codeName = hydrated.codeName;
        _this.maxRedemptions = _this.convertInt(hydrated.maxRedemptions, 1);
        _this.__mc = 'DiscountModel';
        return _this;
    }
    DiscountModel.prototype.hydrate = function (data) {
        var discount = {};
        discount['id'] = data.discount_id || data.id || null;
        discount['discount_id'] = data.discount_id || null;
        discount['name'] = data.name || '';
        discount['active'] = data.active || false;
        discount['amount'] = +data.amount || 0;
        discount['code'] = +data.code || 4 /* BUNDLE */;
        discount['type'] = _super.prototype.convertInt.call(this, data.type, 2 /* TARGET_PRICE */);
        discount['isOnline'] = _super.prototype.convertBool.call(this, data.on_online);
        discount['isLocal'] = _super.prototype.convertBool.call(this, data.is_local);
        discount['minItemCount'] = +data.min_item_count || 1;
        discount['minSubtotal'] = +data.min_subtotal || null;
        discount['minAfterSubtotal'] = data.min_subtotal_after_discount;
        discount['target'] = data.target || null;
        discount['groups'] = null;
        if (data.groups) {
            discount['groups'] = map(data.groups, function (group) {
                return new GroupModel(group);
            });
        }
        discount['codeName'] = data.code_name || data.codeName || '';
        discount['rewardId'] = data.reward_id || data.rewardId || '';
        discount['maxRedemptions'] = data.max_redemptions_per_order;
        discount['menuId'] = data.menu_id || data.menuId || null;
        return discount;
    };
    DiscountModel.prototype.hydrateFromStore = function (data) {
        var discount = {};
        discount = data;
        return discount;
    };
    DiscountModel.prototype.export = function () {
        var discountId = this.discount_id;
        if (discountId.indexOf(':') !== -1) {
            var terms = discountId.split(':');
            var exportedDiscount = {};
            var key = terms[0];
            var value = terms[1];
            exportedDiscount[key] = value;
            return exportedDiscount;
        }
        return {
            menu_id: this.menuId,
            discount_id: this.id,
        };
    };
    DiscountModel.prototype.isForOrder = function () {
        if (this.target === 'order') {
            return true;
        }
        return false;
    };
    DiscountModel.prototype.getOptionsInDiscount = function () {
        var groups = this.groups;
        var options = [];
        forEach(groups, function (group) {
            if (group.options) {
                forEach(group.options, function (option) {
                    options.push(option);
                });
            }
        });
        var flattenedOptions = flattenDeep(options);
        return flattenedOptions;
    };
    DiscountModel.prototype.calculatePercent = function (amount, price) {
        return price * (amount / 1000);
    };
    DiscountModel.prototype.calculateDiscountForItem = function (item, optionExceptions) {
        var discountedPrice = 0;
        switch (this.type) {
            case 1 /* PERCENT */: {
                var itemPrice = item.getSingleItemTotal();
                discountedPrice = this.calculatePercent(this.amount, itemPrice);
                break;
            }
            case 0 /* AMOUNT */: {
                discountedPrice = this.amount;
                break;
            }
            case 2 /* TARGET_PRICE */: {
                var itemPrice = (!item.bundle) ? item.getBasePrice(optionExceptions) : item.bundle.getBundleBasePrice(optionExceptions);
                discountedPrice = itemPrice - this.amount;
                break;
            }
            default: {
                discountedPrice = this.amount;
                break;
            }
        }
        return discountedPrice;
    };
    DiscountModel.prototype.getPercentAmount = function () {
        var type = this.type;
        if (type === 1 /* PERCENT */) {
            return (this.amount / 10);
        }
        return null;
    };
    DiscountModel.prototype.discountPriceForItem = function (item, optionExceptions) {
        var discount = this.calculateDiscountForItem(item, optionExceptions);
        return discount;
    };
    DiscountModel.prototype.messageForTarget = function () {
        var target = this.target;
        if (target === "item" /* ITEM */) {
            return "Coupon Available! (" + this.name + ")";
        }
        if (target === "order" /* ORDER */) {
            return 'Applying Discount...';
        }
        return '';
    };
    DiscountModel.prototype.isCouponBased = function () {
        var couponCode = this.codeName;
        if (couponCode) {
            return true;
        }
        return false;
    };
    DiscountModel.prototype.isUpsell = function () {
        var id = this.id;
        var customIds = ("" + id).split(':');
        if (customIds.length > 1) {
            if (customIds[0] === 'upsell_id') {
                var upsellId = customIds[1];
                return upsellId;
            }
        }
        return false;
    };
    return DiscountModel;
}(BaseModel));
export default DiscountModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/DiscountModel.ts
// module id = Cle3
// module chunks = 18